import HelpOutlineIcon from "@mui/icons-material/HelpOutline";
import { Box, Stack, Tooltip, Typography, useTheme } from "@mui/material";
import { ChartsLabelMark, useLegend } from "@mui/x-charts";

const UsageOverTimeLegend = ({ hideExpectedUsage, unitLabel = "Unit" }: { hideExpectedUsage?: boolean; unitLabel: string }) => {
  const theme = useTheme();
  const { items } = useLegend();

  return (
    <Stack direction="row" gap={1} px={1}>
      {items.map((item) => {
        const { id, color, markType } = item;

        return (
          <Box
            key={id}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1,
            }}
          >
            <ChartsLabelMark color={color} type={markType} />
            <Typography sx={{ display: "inline-block" }}>{unitLabel}s Used</Typography>
          </Box>
        );
      })}
      {!hideExpectedUsage && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <ChartsLabelMark color={theme.palette.error.main} type="line" />
          <Typography sx={{ display: "inline-block" }}>Expected Usage</Typography>
          <Tooltip title="The average usage target across the displayed timeframe">
            <HelpOutlineIcon fontSize="small" sx={{ color: theme.palette.grey[600], verticalAlign: "middle", cursor: "help" }} />
          </Tooltip>
        </Box>
      )}
    </Stack>
  );
};

export default UsageOverTimeLegend;
